import { createContext, MutableRefObject } from 'react';

// This context is used to send specific data from vertical list of list (RailList) to down the component tree

const RailListContext = createContext<{
  setListIndex:  MutableRefObject<(newIndex: number, increment?: number) => void>;
}>({
  setListIndex:  {current: (newIndex: number, increment?: number) => null}
});

export default RailListContext;
